<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-28 13:59:27
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-28 14:00:01
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/cooperativeColonel/list/components/tableCell/leaderInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row-align-center">
			<platform-icon :platformId="row.platform_id" class="flex-shrink"></platform-icon>
			<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.institution_name">
				<p class="yx-color-text-primary font-h6-medium ml-4" style="width: 100%">{{ row.institution_name }}</p>
			</el-tooltip>
		</div>

		<p class="yx-color-text-regular font-h6-regular">
			<span>机构ID：{{ row.authority_id }}</span>
		</p>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
};
</script>
